import { useAppSelector } from '@/redux/hooks/useAppSelector';
import { mainMapModelSelector, modelsDataSelector } from '@/redux/models/models.selectors';
import { DrawerHeading } from '@/shared/DrawerHeading';
import { useAppDispatch } from '@/redux/hooks/useAppDispatch';
import { openMapAndSetActive, setActiveMap } from '@/redux/map/map.slice';
import { MapModel } from '@/types/models';
import { mapModelIdSelector, mapOpenedMapsSelector } from '@/redux/map/map.selectors';
import { PluginsEventBus } from '@/services/pluginsManager/pluginsEventBus';
import { ONE } from '@/constants/common';
import { openExportDrawer } from '@/redux/drawer/drawer.slice';
import { SubmapItem } from './SubmapItem/SubmapItem.component';

export const SubmapsDrawer = (): JSX.Element => {
  const models = useAppSelector(modelsDataSelector);
  const mainModel = useAppSelector(mainMapModelSelector);
  const openedMaps = useAppSelector(mapOpenedMapsSelector);
  const currentModelId = useAppSelector(mapModelIdSelector);
  const dispatch = useAppDispatch();

  const sortedModels = [...models].sort((a, b) => {
    if (a.id === mainModel?.id) {
      return -ONE;
    }
    if (b.id === mainModel?.id) {
      return ONE;
    }
    return a.name.localeCompare(b.name);
  });

  const isMapAlreadyOpened = (modelId: number): boolean =>
    openedMaps.some(map => map.modelId === modelId);

  const onSubmapOpenClick = (model: MapModel): void => {
    if (isMapAlreadyOpened(model.id)) {
      dispatch(setActiveMap({ modelId: model.id }));
    } else {
      dispatch(openMapAndSetActive({ modelId: model.id, modelName: model.name }));
    }
    if (currentModelId !== model.id) {
      PluginsEventBus.dispatchEvent('onSubmapClose', currentModelId);
      PluginsEventBus.dispatchEvent('onSubmapOpen', model.id);
    }
  };

  const onSubmapDownloadClick = (model: MapModel): void => {
    dispatch(openExportDrawer(model.id));
  };

  return (
    <div data-testid="submap-drawer" className="h-full max-h-full">
      <DrawerHeading title="Submaps" />
      <ul className="h-[calc(100%-93px)] max-h-[calc(100%-93px)] overflow-y-auto px-6">
        {sortedModels.map(model => (
          <SubmapItem
            key={model.id}
            modelName={model.name}
            onOpenClick={(): void => onSubmapOpenClick(model)}
            onDownloadClick={(): void => onSubmapDownloadClick(model)}
          />
        ))}
      </ul>
    </div>
  );
};
